/**
 * Collection Facets with AJAX Filtering
 * Handles product filtering without page reloads
 */

class CollectionFacets {
  constructor() {
    this.filterContainer = document.querySelector('[data-collection-filters]');
    this.productGrid = document.querySelector('.collection__list');
    this.loadMoreButton = document.querySelector('[data-load-more]');
    this.sortFilter = document.querySelector('[data-sort-filter]');
    this.mainFilter = document.querySelector('[data-main-filter]');
    this.categoriesFilter = document.querySelector('[data-categories-filter]');
    this.currentUrl = new URL(window.location);
    
    console.log('CollectionFacets initialized with elements:', {
      filterContainer: !!this.filterContainer,
      productGrid: !!this.productGrid,
      loadMoreButton: !!this.loadMoreButton,
      sortFilter: !!this.sortFilter,
      mainFilter: !!this.mainFilter,
      categoriesFilter: !!this.categoriesFilter
    });
    this.isLoading = false;
    this.allProducts = []; // Store all product cards for client-side filtering
    this.activeFilters = {
      tags: [],
      vendor: [],
      product_type: [],
      price: { min: null, max: null }
    };
    
    this.init();
  }

  init() {
    if (!this.filterContainer) {
      console.log('Filter container not found!');
      return;
    }
    
    // Debug: Check if categories button exists
    const categoriesButton = document.querySelector('[data-toggle-categories]');
    console.log('Categories button found:', !!categoriesButton);
    if (categoriesButton) {
      console.log('Categories button element:', categoriesButton);
      console.log('Categories button classes:', categoriesButton.className);
    }
    
    // Debug: Check available price filters
    const allPriceFilters = document.querySelectorAll('[data-price-filter]');
    console.log('Available price filters:', allPriceFilters.length);
    allPriceFilters.forEach((filter, index) => {
      console.log(`Price filter ${index}:`, {
        min: filter.dataset.min,
        max: filter.dataset.max,
        value: filter.value,
        name: filter.name,
        checked: filter.checked
      });
    });
    
    this.storeAllProducts();
    this.loadSavedFilters();
    this.bindEvents();
    this.updateActiveFilters();
    this.applyClientSideFilters();
  }

  storeAllProducts() {
    // Store all product elements for client-side filtering
    if (this.productGrid) {
      this.allProducts = Array.from(this.productGrid.querySelectorAll('.card-product'));
      console.log('Stored', this.allProducts.length, 'products for filtering');
      
      // Debug: Check if products have price data
      if (this.allProducts.length > 0) {
        const firstProduct = this.allProducts[0];
        console.log('First product data attributes:', {
          productPrice: firstProduct.dataset.productPrice,
          productTags: firstProduct.dataset.productTags,
          productVendor: firstProduct.dataset.productVendor,
          productType: firstProduct.dataset.productType
        });
      }
    }
  }

  loadSavedFilters() {
    // Load saved filters from localStorage
    const savedFilters = localStorage.getItem('collection-filters');
    if (savedFilters) {
      try {
        this.activeFilters = JSON.parse(savedFilters);
        console.log('Loaded saved filters:', this.activeFilters);
      } catch (e) {
        console.error('Error loading saved filters:', e);
      }
    }
  }

  saveFilters() {
    // Save current filters to localStorage
    localStorage.setItem('collection-filters', JSON.stringify(this.activeFilters));
  }

  bindEvents() {
    // Category filter buttons
    this.filterContainer.addEventListener('click', (e) => {
      console.log('Click event detected on:', e.target);
      console.log('Event target classes:', e.target.className);
      
      const categoryButton = e.target.closest('[data-filter-type="collection"]');
      if (categoryButton) {
        console.log('Category filter button clicked:', categoryButton);
        e.preventDefault();
        this.handleCategoryFilter(categoryButton);
      }

      // Toggle filter panels
      const toggleCategories = e.target.closest('[data-toggle-categories]');
      const toggleFilters = e.target.closest('[data-toggle-filters]');
      const closeFilter = e.target.closest('[data-close-filter]');

      console.log('Toggle elements found:', {
        toggleCategories: !!toggleCategories,
        toggleFilters: !!toggleFilters,
        closeFilter: !!closeFilter
      });

      if (toggleCategories) {
        console.log('Toggle categories clicked, categoriesFilter element:', this.categoriesFilter);
        this.toggleFilterPanel(this.categoriesFilter);
      }
      if (toggleFilters) {
        console.log('Toggle filters clicked');
        this.toggleFilterPanel(this.mainFilter);
      }
      if (closeFilter) {
        console.log('Close filter clicked');
        this.closeFilterPanels();
      }
    });

    // Sort options, category selections and filter checkboxes
    this.filterContainer.addEventListener('change', (e) => {
      console.log('Change event detected:', e.target); // Debug
      
      const sortOption = e.target.closest('[data-sort-option]');
      if (sortOption) {
        this.handleSortChange(sortOption.value);
        return;
      }

      // Category radio button selection
      const categoryOption = e.target.closest('input[name="category_filter"]');
      if (categoryOption) {
        this.handleCategorySelection(categoryOption);
        return;
      }

      // Filter checkboxes - check for any checkbox change
      if (e.target.type === 'checkbox') {
        console.log('Checkbox changed:', e.target.name, e.target.value, e.target.checked); // Debug
        
        // Special debugging for price filters
        if (e.target.hasAttribute('data-price-filter')) {
          console.log('Price filter checkbox changed:', {
            min: e.target.dataset.min,
            max: e.target.dataset.max,
            value: e.target.value,
            checked: e.target.checked,
            name: e.target.name
          });
        }
        
        this.handleFilterChange();
        return;
      }

      // Legacy filter detection
      const priceFilter = e.target.closest('[data-price-filter]');
      const tagFilter = e.target.closest('[data-tag-filter]');
      const optionFilter = e.target.closest('[data-option-filter]');

      if (priceFilter || tagFilter || optionFilter) {
        console.log('Filter detected:', { priceFilter: !!priceFilter, tagFilter: !!tagFilter, optionFilter: !!optionFilter }); // Debug
        this.handleFilterChange();
      }
    });

    // Load more button
    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.loadMoreProducts();
      });
    }

    // Close filters when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.collection__filter') && 
          !e.target.closest('[data-toggle-categories]') && 
          !e.target.closest('[data-toggle-filters]')) {
        this.closeFilterPanels();
      }
    });
  }

  handleCategoryFilter(button) {
    const filterValue = button.dataset.filterValue;
    const collectionUrl = button.dataset.collectionUrl;
    const isActive = button.classList.contains('is-active');

    // If clicking already active button, do nothing
    if (isActive) {
      return;
    }

    // Remove active class from all category buttons
    this.filterContainer.querySelectorAll('.actions__button').forEach(btn => {
      btn.classList.remove('is-active');
    });

    // Add active class to clicked button
      button.classList.add('is-active');
      
      // If collection URL exists, navigate to that collection
    // Filters will be preserved via localStorage
      if (collectionUrl) {
        window.location.href = collectionUrl;
        return;
      } else {
        // Otherwise use tag filtering
      this.currentUrl.search = '';  // Clear existing filters
        this.updateUrlParam('filter.v.tag', filterValue);
      this.fetchFilteredProducts();
    }
  }

  handleSortChange(sortValue) {
    this.updateUrlParam('sort_by', sortValue);
    this.fetchFilteredProducts();
  }

  handleCategorySelection(categoryInput) {
    const filterValue = categoryInput.dataset.filterValue;
    const collectionUrl = categoryInput.dataset.collectionUrl;
    
    // Close the categories filter panel
    this.closeFilterPanels();
    
    // Remove active class from all category buttons in the actions list
    this.filterContainer.querySelectorAll('.actions__button').forEach(btn => {
      btn.classList.remove('is-active');
    });

    // Add active class to corresponding button in actions list
    const correspondingButton = this.filterContainer.querySelector(`[data-filter-value="${filterValue}"]`);
    if (correspondingButton) {
      correspondingButton.classList.add('is-active');
    }
      
    // If collection URL exists, navigate to that collection
    if (collectionUrl) {
      window.location.href = collectionUrl;
      return;
    } else {
      // Otherwise use tag filtering
      this.currentUrl.search = '';  // Clear existing filters
      this.updateUrlParam('filter.v.tag', filterValue);
      this.fetchFilteredProducts();
    }
  }

  handleFilterChange() {
    console.log('handleFilterChange called'); // Debug
    
    // Reset active filters
    this.activeFilters = {
      tags: [],
      vendor: [],
      product_type: [],
      price: { min: null, max: null }
    };

    // Collect tag filters
    const tagFilters = this.filterContainer.querySelectorAll('[data-tag-filter]:checked');
    console.log('Tag filters found:', tagFilters.length); // Debug
    tagFilters.forEach(filter => {
      const tagHandle = filter.dataset.tagHandle;
      console.log('Tag filter:', tagHandle); // Debug
      if (tagHandle) {
        this.activeFilters.tags.push(tagHandle);
      }
    });

    // Collect vendor filters
    const vendorFilters = this.filterContainer.querySelectorAll('input[name="filter.v.vendor"]:checked');
    vendorFilters.forEach(filter => {
      this.activeFilters.vendor.push(filter.value);
    });

    // Collect product type filters
    const productTypeFilters = this.filterContainer.querySelectorAll('input[name="filter.v.product_type"]:checked');
    productTypeFilters.forEach(filter => {
      this.activeFilters.product_type.push(filter.value);
    });

    // Collect price filters
    const priceFilters = this.filterContainer.querySelectorAll('[data-price-filter]:checked');
    console.log('Price filters found:', priceFilters.length); // Debug
    console.log('All price filter elements:', this.filterContainer.querySelectorAll('[data-price-filter]').length);
    
    priceFilters.forEach((filter, index) => {
      const min = parseFloat(filter.dataset.min);
      const max = filter.dataset.max && filter.dataset.max !== '' ? parseFloat(filter.dataset.max) : null;
      
      console.log(`Price filter ${index}:`, {
        element: filter,
        min: min,
        max: max,
        checked: filter.checked,
        value: filter.value,
        name: filter.name
      });
      
      if (!this.activeFilters.price.min || min < this.activeFilters.price.min) {
        this.activeFilters.price.min = min;
      }
      if (!this.activeFilters.price.max || (max && max > this.activeFilters.price.max)) {
        this.activeFilters.price.max = max;
      }
    });

    console.log('Active filters:', this.activeFilters); // Debug

    // Save filters and apply client-side filtering
    this.saveFilters();
    this.applyClientSideFilters();
  }

  toggleFilterPanel(panel) {
    console.log('toggleFilterPanel called with panel:', panel);
    if (!panel) {
      console.log('Panel is null or undefined!');
      return;
    }
    
    const isVisible = panel.style.display === 'block' || (!panel.style.display && panel.offsetParent !== null);
    console.log('Panel visibility before toggle:', isVisible);
    
    this.closeFilterPanels();
    
    if (!isVisible) {
      console.log('Opening panel...');
      panel.style.display = 'block';
      panel.classList.add('is-open');
      console.log('Panel opened, display style:', panel.style.display);
    }
  }

  closeFilterPanels() {
    const panels = [this.sortFilter, this.mainFilter, this.categoriesFilter];
    panels.forEach(panel => {
      if (panel) {
        panel.style.display = 'none';
        panel.classList.remove('is-open');
      }
    });
  }

  updateUrlParam(key, value) {
    if (value) {
      this.currentUrl.searchParams.set(key, value);
    } else {
      this.currentUrl.searchParams.delete(key);
    }
  }

  removeUrlParam(key) {
    this.currentUrl.searchParams.delete(key);
  }

  applyClientSideFilters() {
    if (!this.productGrid || this.allProducts.length === 0) return;

    let visibleCount = 0;
    const hasActiveFilters = this.hasActiveFilters();

    this.allProducts.forEach(product => {
      const shouldShow = this.productMatchesFilters(product);
      
      if (shouldShow) {
        product.style.display = '';
        product.closest('.collection__item').style.display = '';
        visibleCount++;
      } else {
        product.style.display = 'none';
        product.closest('.collection__item').style.display = 'none';
      }
    });

    console.log(`Showing ${visibleCount} of ${this.allProducts.length} products`);

    // Update product count in header
    this.updateProductCount(visibleCount);

    // Show/hide empty state
    this.toggleEmptyState(visibleCount === 0 && hasActiveFilters);
  }

  hasActiveFilters() {
    return this.activeFilters.tags.length > 0 ||
           this.activeFilters.vendor.length > 0 ||
           this.activeFilters.product_type.length > 0 ||
           this.activeFilters.price.min !== null ||
           this.activeFilters.price.max !== null;
  }

  productMatchesFilters(productElement) {
    const productTags = productElement.dataset.productTags ? 
      productElement.dataset.productTags.split(',').map(tag => tag.trim()) : [];
    const productVendor = productElement.dataset.productVendor || '';
    const productType = productElement.dataset.productType || '';
    const productPrice = parseFloat(productElement.dataset.productPrice) / 100; // Convert from cents
    
    console.log('Checking product:', {
      element: productElement,
      tags: productTags,
      vendor: productVendor,
      type: productType,
      price: productPrice,
      priceDataset: productElement.dataset.productPrice
    });

    // Check tag filters
    if (this.activeFilters.tags.length > 0) {
      const hasMatchingTag = this.activeFilters.tags.some(filterTag => 
        productTags.includes(filterTag)
      );
      if (!hasMatchingTag) return false;
    }

    // Check vendor filters
    if (this.activeFilters.vendor.length > 0) {
      if (!this.activeFilters.vendor.includes(productVendor)) return false;
    }

    // Check product type filters
    if (this.activeFilters.product_type.length > 0) {
      if (!this.activeFilters.product_type.includes(productType)) return false;
    }

    // Check price filters
    if (this.activeFilters.price.min !== null && productPrice < this.activeFilters.price.min) {
      console.log('Product filtered out by min price:', productPrice, '<', this.activeFilters.price.min);
      return false;
    }
    if (this.activeFilters.price.max !== null && productPrice > this.activeFilters.price.max) {
      console.log('Product filtered out by max price:', productPrice, '>', this.activeFilters.price.max);
      return false;
    }

    return true;
  }

  toggleEmptyState(showEmpty) {
    let emptyState = document.querySelector('.collection__empty');
    
    if (showEmpty) {
      if (!emptyState) {
        // Create empty state if it doesn't exist
        const emptyHTML = `
          <div class="collection__empty">
            <div class="collection__empty-inner">
              <h3>No products found</h3>
              <p>Try adjusting your filters or search terms.</p>
              <button 
                class="button collection__clear-filters" 
                type="button"
                data-clear-filters>
                Clear all filters
              </button>
            </div>
          </div>
        `;
        this.productGrid.insertAdjacentHTML('afterend', emptyHTML);
        
        // Bind clear filters button
        document.querySelector('[data-clear-filters]').addEventListener('click', () => {
          this.clearAllFilters();
        });
      } else {
        emptyState.style.display = 'block';
      }
      this.productGrid.style.display = 'none';
    } else {
      if (emptyState) {
        emptyState.style.display = 'none';
      }
      this.productGrid.style.display = '';
    }
  }

  clearAllFilters() {
    // Clear active filters
    this.activeFilters = {
      tags: [],
      vendor: [],
      product_type: [],
      price: { min: null, max: null }
    };

    // Clear all checkboxes
    this.filterContainer.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.checked = false;
    });

    // Save and apply
    this.saveFilters();
    this.applyClientSideFilters();
  }

  async fetchFilteredProducts() {
    if (this.isLoading) return;
    
    this.isLoading = true;
    this.showLoading();

    try {
      // Use section rendering API for better performance
      const fetchUrl = new URL(this.currentUrl);
      fetchUrl.searchParams.delete('page'); // Reset page for filtering
      fetchUrl.searchParams.set('section_id', 'main-collection-product-grid');

      console.log('Fetching URL:', fetchUrl.toString()); // Debug

      const response = await fetch(fetchUrl.toString(), {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (response.ok) {
        const html = await response.text();
        console.log('Response received'); // Debug
        
        // When using section_id, the response is just the section HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSection = doc.querySelector('#main-collection-product-grid') || doc.body.firstElementChild;
        
        if (newSection) {
          const newProductGrid = newSection.querySelector('.collection__list');
          const newPagination = newSection.querySelector('.collection__pagination');
          const newHeader = newSection.querySelector('.collection__header');
          const newBody = newSection.querySelector('.collection__body');

          console.log('Found elements:', {
            newProductGrid: !!newProductGrid,
            newPagination: !!newPagination,
            newHeader: !!newHeader,
            newBody: !!newBody
          }); // Debug

          // Update the entire collection body (includes empty state)
          if (newBody) {
            const currentBody = document.querySelector('.collection__body');
            if (currentBody) {
              currentBody.innerHTML = newBody.innerHTML;
              console.log('Updated collection body');
            }
          } else if (newProductGrid && this.productGrid) {
            // Fallback: update just the product grid
            this.productGrid.innerHTML = newProductGrid.innerHTML;
            console.log('Updated product grid');
          }

          // Update header (includes product count)
          if (newHeader) {
            const currentHeader = document.querySelector('.collection__header');
            if (currentHeader) {
              // Only update the header body, not the controls
              const newHeaderBody = newHeader.querySelector('.collection__header-body');
              const currentHeaderBody = currentHeader.querySelector('.collection__header-body');
              if (newHeaderBody && currentHeaderBody) {
                currentHeaderBody.innerHTML = newHeaderBody.innerHTML;
                console.log('Updated header');
              }
            }
          }

          // Re-bind load more button if it exists
              this.rebindLoadMoreButton();

          console.log('Filter update completed');
        } else {
          console.error('Could not find main section in response');
        }
      } else {
        console.error('Fetch failed with status:', response.status);
        throw new Error('Fetch failed');
      }

      // Update URL without page reload
      window.history.pushState(null, '', this.currentUrl.toString());

    } catch (error) {
      console.error('Error fetching filtered products:', error);
      // Fallback: reload the page
      window.location.href = this.currentUrl.toString();
    } finally {
      this.isLoading = false;
      this.hideLoading();
    }
  }

  async loadMoreProducts() {
    if (this.isLoading) return;

    const currentPage = parseInt(this.currentUrl.searchParams.get('page') || '1');
    const nextPage = currentPage + 1;
    
    this.updateUrlParam('page', nextPage);
    
    this.isLoading = true;
    this.showLoadMoreLoading();

    try {
      const fetchUrl = new URL(this.currentUrl);
      fetchUrl.searchParams.set('section_id', 'main-collection-product-grid');

      const response = await fetch(fetchUrl.toString(), {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (response.ok) {
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSection = doc.querySelector('#main-collection-product-grid');
        
        if (newSection) {
          const newProducts = newSection.querySelectorAll('.collection__item');
          const newPagination = newSection.querySelector('.collection__pagination');

          // Append new products
          if (newProducts.length > 0 && this.productGrid) {
            newProducts.forEach(product => {
              this.productGrid.appendChild(product.cloneNode(true));
            });
          }

          // Update pagination button
          const paginationContainer = document.querySelector('.collection__pagination');
          if (paginationContainer) {
            if (newPagination) {
              paginationContainer.innerHTML = newPagination.innerHTML;
              this.rebindLoadMoreButton();
            } else {
              paginationContainer.style.display = 'none';
            }
          }
        }
      }

      // Update URL
      window.history.pushState(null, '', this.currentUrl.toString());

    } catch (error) {
      console.error('Error loading more products:', error);
      // Revert page number on error
      this.updateUrlParam('page', currentPage);
    } finally {
      this.isLoading = false;
      this.hideLoadMoreLoading();
    }
  }

  reinitialize() {
    // Re-initialize after content update
    this.filterContainer = document.querySelector('[data-collection-filters]');
    this.productGrid = document.querySelector('.collection__list');
    this.loadMoreButton = document.querySelector('[data-load-more]');
    this.sortFilter = document.querySelector('[data-sort-filter]');
    this.mainFilter = document.querySelector('[data-main-filter]');
    this.categoriesFilter = document.querySelector('[data-categories-filter]');
    
    // Re-store products and apply filters
    this.storeAllProducts();
    this.updateActiveFilters();
    this.applyClientSideFilters();
    
    // Ensure filters are closed
    this.closeFilterPanels();
  }

  rebindLoadMoreButton() {
    this.loadMoreButton = document.querySelector('[data-load-more]');
    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.loadMoreProducts();
      });
    }
  }

  updateActiveFilters() {
    // Clear all active states first
    this.filterContainer.querySelectorAll('.actions__button').forEach(btn => {
      btn.classList.remove('is-active');
    });

    // Get current collection handle from window location
    const currentPath = window.location.pathname;
    const collectionMatch = currentPath.match(/\/collections\/([^\/]+)/);
    const currentCollection = collectionMatch ? collectionMatch[1] : null;

    // Update active category button based on current collection
    if (currentCollection) {
      const activeButton = this.filterContainer.querySelector(`[data-filter-value="${currentCollection}"], [data-collection-url="/collections/${currentCollection}"]`);
      if (activeButton) {
        activeButton.classList.add('is-active');
      }
    }

    // Update active sort option
    const activeSortBy = this.currentUrl.searchParams.get('sort_by');
    if (activeSortBy) {
      const activeSortOption = this.filterContainer.querySelector(`[data-sort-option][value="${activeSortBy}"]`);
      if (activeSortOption) {
        activeSortOption.checked = true;
      }
    }

    // Update filter checkboxes based on saved filters
    this.updateFilterCheckboxesFromSaved();
  }

  updateFilterCheckboxesFromSaved() {
    console.log('Updating checkboxes from saved filters:', this.activeFilters);

    // Clear all checkboxes first
    this.filterContainer.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.checked = false;
    });

    // Check tag filters
    this.activeFilters.tags.forEach(tag => {
      const filter = this.filterContainer.querySelector(`[data-tag-filter][data-tag-handle="${tag}"]`);
      if (filter) filter.checked = true;
    });

    // Check vendor filters
    this.activeFilters.vendor.forEach(vendor => {
      const filter = this.filterContainer.querySelector(`input[name="filter.v.vendor"][value="${vendor}"]`);
      if (filter) filter.checked = true;
    });

    // Check product type filters
    this.activeFilters.product_type.forEach(type => {
      const filter = this.filterContainer.querySelector(`input[name="filter.v.product_type"][value="${type}"]`);
      if (filter) filter.checked = true;
    });

    // Check price filters based on range
    if (this.activeFilters.price.min !== null || this.activeFilters.price.max !== null) {
      this.filterContainer.querySelectorAll('[data-price-filter]').forEach(filter => {
        const min = parseFloat(filter.dataset.min);
        const max = filter.dataset.max && filter.dataset.max !== '' ? parseFloat(filter.dataset.max) : null;
        
        const matchesMin = this.activeFilters.price.min === null || min >= this.activeFilters.price.min;
        const matchesMax = this.activeFilters.price.max === null || (max && max <= this.activeFilters.price.max);
        
        if (matchesMin && matchesMax) {
          filter.checked = true;
        }
      });
    }
  }

  updateFilterCheckboxes() {
    console.log('Updating filter checkboxes from URL:', this.currentUrl.search); // Debug
    
    // Clear all checkboxes first
    this.filterContainer.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.checked = false;
    });

    // Price filters - convert back from cents and match ranges
    const priceGte = this.currentUrl.searchParams.getAll('filter.v.price.gte');
    const priceLte = this.currentUrl.searchParams.getAll('filter.v.price.lte');
    
    console.log('Price filters from URL:', { priceGte, priceLte }); // Debug
    
    // Match price ranges
    this.filterContainer.querySelectorAll('[data-price-filter]').forEach(filter => {
      const min = filter.dataset.min;
      const max = filter.dataset.max;
      const minCents = min ? (parseFloat(min) * 100).toString() : '';
      const maxCents = max && max !== '' ? (parseFloat(max) * 100).toString() : '';
      
      const hasMinMatch = !min || priceGte.includes(minCents);
      const hasMaxMatch = !max || max === '' || priceLte.includes(maxCents);
      
      if (hasMinMatch && hasMaxMatch && (priceGte.length > 0 || priceLte.length > 0)) {
        // Additional check: ensure this specific range is selected
        const range = filter.dataset.range;
        if (range) {
          const [rangeMin, rangeMax] = range.split('-');
          const rangeMinCents = rangeMin ? (parseFloat(rangeMin) * 100).toString() : '';
          const rangeMaxCents = rangeMax && rangeMax !== '' ? (parseFloat(rangeMax) * 100).toString() : '';
          
          if (priceGte.includes(rangeMinCents) || (rangeMax && priceLte.includes(rangeMaxCents))) {
            filter.checked = true;
          }
        }
      }
    });

    // Tag filters
    const tags = this.currentUrl.searchParams.getAll('filter.v.tag');
    console.log('Tag filters from URL:', tags); // Debug
    tags.forEach(tag => {
      const filter = this.filterContainer.querySelector(`[data-tag-filter][data-tag-handle="${tag}"]`);
      console.log(`Looking for tag filter: ${tag}`, !!filter); // Debug
      if (filter) filter.checked = true;
    });

    // Vendor filters
    const vendors = this.currentUrl.searchParams.getAll('filter.v.vendor');
    vendors.forEach(vendor => {
      const filter = this.filterContainer.querySelector(`input[name="filter.v.vendor"][value="${vendor}"]`);
      if (filter) filter.checked = true;
    });

    // Product type filters
    const productTypes = this.currentUrl.searchParams.getAll('filter.v.product_type');
    productTypes.forEach(type => {
      const filter = this.filterContainer.querySelector(`input[name="filter.v.product_type"][value="${type}"]`);
      if (filter) filter.checked = true;
    });

    // Other option filters
    const allParams = Array.from(this.currentUrl.searchParams.entries());
    allParams.forEach(([key, value]) => {
      if (key.startsWith('filter.v.option.')) {
        const filter = this.filterContainer.querySelector(`[data-option-filter][name="${key}"][value="${value}"]`);
        if (filter) filter.checked = true;
      }
    });
  }

  updateProductCount(count) {
    const countElement = document.querySelector('.title sup');
    
    if (countElement) {
      countElement.textContent = `[ ${count} ]`;
    }
  }

  showLoading() {
    if (this.productGrid) {
      this.productGrid.style.opacity = '0.5';
      this.productGrid.style.pointerEvents = 'none';
    }
  }

  hideLoading() {
    if (this.productGrid) {
      this.productGrid.style.opacity = '1';
      this.productGrid.style.pointerEvents = 'auto';
    }
  }

  showLoadMoreLoading() {
    if (this.loadMoreButton) {
      this.loadMoreButton.textContent = 'Loading...';
      this.loadMoreButton.disabled = true;
    }
  }

  hideLoadMoreLoading() {
    if (this.loadMoreButton) {
      this.loadMoreButton.textContent = this.loadMoreButton.dataset.originalText || 'Load more';
      this.loadMoreButton.disabled = false;
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CollectionFacets();
});

// Re-initialize for theme editor
document.addEventListener('shopify:section:load', () => {
  new CollectionFacets();
});
